var DoT = require('dot');

 

module.exports = {
	query_vip_info(callback) {
	    $.ajax({
	        url: '//mvip.midea.cn/my/muc/promote_user_info',
	        'type': 'GET',
	        'data': {},
	        'dataType': 'jsonp',
	        'timeout': 10000,
	        success(res) {
	            console.log(res);
	            if (res.err_code == 0) {
	                callback && callback(res.data);
	            }else{
	            	console.log(res.errmsg);
	            }
	        }
	    });
	},
	render(data){
		$('.js_widget_vipcard').each(function(index,item){
			var widgetConf = $(item).attr('data-widget-conf')
			if(widgetConf){
				widgetConf = JSON.parse($(item).attr('data-widget-conf'));
				data.welfareH5Href = `${data.welfareH5Href}?mtag=${widgetConf.welfare_link_mtag}`;
			    data.welfareSPHref = `${data.welfareSPHref}?mtag=${widgetConf.welfare_link_mtag}`;//小程序path
			    data.signinHref = `${data.signinHref}?mtag=${widgetConf.signin_link_mtag}`;
			    data.signinSPHref = `${data.signinSPHref}?mtag=${widgetConf.signin_link_mtag}`;
				$(item).html(DoT.template($('#vipcardTmpl').html())({data:{vipData:data}}));
				//更新权益图
			

				
				$('#user_info_box').addClass(data.level_bg_name);
				var rightImgName = '';
				if(data.nProFlag != 0){
		            rightImgName = 'pro';
		        }else
				if(data.vip_level == 1){
		           rightImgName = 'common';
		        }else if(data.vip_level == 2){
		            rightImgName = 'gold';
		        }else if(data.vip_level == 3){
		            rightImgName = 'diamond';
		        }else{
		            rightImgName = 'common';
		        }

		        if(widgetConf[`vip_right_img_${rightImgName}`]){//有配置权益图
		        	$('.vip_right_img_box').attr('src',widgetConf[`vip_right_img_${rightImgName}`]);
		        }else{//无，隐藏更多按钮
		        	$('.vip_right_img_box').css('display','none');
		        	$('.more-right').css('display','none');
		        	$('#user_info_box').css('padding-bottom',0);
		        }
		        
			}
			
		});

		
	},
	eventBind(data){
		$('#go_to_signin a').on('click',function(){//签到页
			if(IsWxMiniProgram){//小程序环境，默认商城小程序
				if(window.miniapp == 'portal'){//会员小程序
					wx.miniProgram.navigateTo({
                        url:data.signinSPHref,
                    });
	                return false;
				}
				wx.miniProgram.navigateTo({
                    url:`/page/web_view_promote/web_view_promote?mpappid=${data.spAppId}&mppath=${encodeURIComponent(data.signinSPHref)}`,
                });
                return false;
			}
			return true;
		})
		$('.more-right a').on('click',function(){//查看更多
			if(IsWxMiniProgram){//小程序环境，商城小程序
				if(window.miniapp == 'portal'){//会员小程序
					wx.miniProgram.switchTab({
                        url:data.welfareSPHref,
                    });
	                return false;
				}
				wx.miniProgram.navigateTo({
                    url:`/page/web_view_promote/web_view_promote?mpappid=${data.spAppId}&mppath=${encodeURIComponent(data.welfareSPHref)}`,
                });
                return false;
			}
			return true;
		})
	},
	init(options){
		var that = this;
		if($('.js_widget_vipcard').length > 0){
			if(options){//静默授权
				console.log('IsWxMiniProgram');
				console.log(window.IsWxMiniProgram);
				options.login.start(function(){
					that.query_vip_info(function(data){
						that.render(data);
						that.eventBind(data);
					})
				});
				
			}
			

		}
	}
}


// WEBPACK FOOTER //
// ./module/widget.vipcard.js